import { ReactElement } from 'react';

export type HeapModelClass = 'alpha' | 'stable';

export function normalizeModelClass(value: string | undefined): HeapModelClass {
  return value === 'alpha' ? 'alpha' : 'stable';
}

export interface HeapDetection {
  classes: string[];
  scores: number[];
  bbox: number[]; // [x_min, y_min, x_max, y_max] in pixels
  sources?: string[];
}

export interface HeapImageLog {
  capturer_id: string;
  license_plate?: string;
  started_at?: string;
  stopped_at?: string;
  bucket_name: string;
  object_name: string;
  detections: HeapDetection[];
}

export type CaptureStatus = 'idle' | 'started' | 'uploaded' | 'processed' | 'error';

export interface HeapCaptureState {
  status: CaptureStatus;
  triggerId?: string;
  capturedAt?: Date;
  imageLog?: HeapImageLog;
  imageUrl?: string;
  bucket?: string;
  object?: string;
}

export interface DetectionRow {
  className: string;
  count: number;
  color: string;
}

export interface DetectionRowView {
  label: string;
  count: number;
  color: string;
  modelClass: HeapModelClass;
}

export interface HeapActivityHeaderItem {
  icon: ReactElement;
  label?: string;
  value: any;
}

export type HeapFrameCapturesUploadedEvent = {
  type: 'frame_captures_uploaded';
  capturer_id: string;
  payload: {
    trigger_id: string;
    recorded_at: string;
    bucket_name: string;
    object_name: string;
  };
};

export type HeapDetectionFinishedEvent = {
  type: 'detection_finished';
  capturer_id: string;
  payload: {
    trigger_id: string;
    recorded_at: string;
    bucket_name: string;
    object_name: string;
  };
};
